import { AssistentItem } from '../assistent_config';
import { DateneingabeSachanlagenAuswahl } from '../../DateneingabeSachanlagenAuswahl';
import * as React from 'react';
import { SachanlagenElement } from './custom/SachanlagenElement';

export function getAssistentConfigHinweisSachanlagen(standort: any, data: any, jahr: number, customCfg?: any): AssistentItem {
    const modul: string = (data || {}).MODUL_SELECTED || null;
    const eingangs_hinweise = {
        gliederung: modul === 'cfm' ? '2.5' : '2.4',
        name: 'Sachanlagen: Energieverbräuche unbekannt',
        description: '',
        type: 'CustomElement',
        style: { marginLeft: 18 },
        customElements: [
            <DateneingabeSachanlagenAuswahl
                data={data}
                standortSelected={standort}
                jahrFix={jahr}
                hideJahr
                showHelpIcon
            />,
            <SachanlagenElement
                data={data}
            />
        ],
        ...(customCfg || {})
    };

    return eingangs_hinweise;
}
